import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles/theme.css";

export const fixtureNewsHeaderStyles = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.xs,
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.heading.l,
  fontWeight: 400,
});
